export default {
  computed: {
    isIos() {
      const userAgent = window.navigator.userAgent;
      return (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i));
    },
  },
};



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/mixins/is_ios.js